import { Info as InfoIcon } from '@mui/icons-material';
import React from 'react';
import ErrorBoundary from '../../../../../../common/components/ErrorBoundary';
import Component from './component';

const infoIconStyle = {
  color: '#858585',
  verticalAlign: 'text-top',
  marginLeft: 10,
};

export const hintComponent = (
  <InfoIcon
    style={infoIconStyle}
    fontSize="inherit"
  />
);

function ConfigurationField(props) {
  return (
    <ErrorBoundary errorFallback="Error in Configuration Field">
      <Component {...props} />
    </ErrorBoundary>
  );
}

export default ConfigurationField;
